import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDisplayName } from 'gandi.react-helpers';
import { createAssetPath } from '../createAssetPath';
import { makeWrapHandler } from '../utils';
import { AssetPathContextProvider } from './AssetPathContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const provideAssetPath = (assetEndpoint, manifestContent, assetPrefix) => WrappedComponent => {
  function ProvideAssetPath(props) {
    return /*#__PURE__*/_jsx(AssetPathContextProvider, {
      assetEndpoint: assetEndpoint,
      assetPrefix: assetPrefix,
      manifestContent: manifestContent,
      children: /*#__PURE__*/_jsx(WrappedComponent, {
        ...props
      })
    });
  }
  ProvideAssetPath.WrappedComponent = WrappedComponent;
  ProvideAssetPath.displayName = `ProvideAssetPath(${getDisplayName(WrappedComponent)})`;
  const HoistedComponent = hoistNonReactStatic(ProvideAssetPath, WrappedComponent);
  const wrapHandler = makeWrapHandler(WrappedComponent, HoistedComponent, wrappedHandler => args => {
    const {
      res
    } = args;
    res.locals.assetPath = createAssetPath(assetEndpoint, manifestContent, assetPrefix);
    return wrappedHandler(args);
  });
  wrapHandler('preFetch');
  wrapHandler('handleRedirect');
  wrapHandler('handleForm');
  wrapHandler('handlePageMeta');
  return HoistedComponent;
};
export default provideAssetPath;